import React from 'react';

import { StyleSheet, Text } from 'react-native';
import type { StyleProp, TextStyle } from 'react-native';
import { withTypography } from 'ucl/components/text/Typography';

import { Box, BoxProps } from 'components/ui/box';
import { layout, primitive, spacing } from 'styles/constants';

import { DELIVERY_PROGRESS_COLOR } from './constants';

export const StatusMessage = withTypography({
  variant: 'copyTwo',
  fontSize: 'sm',
  color: primitive.$greyOne,
});

export const StatusMessageContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    focusable: true,
    ...props,
    style,
  });

export const ProgressList = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.progressList, style],
  });

const renderProgressListItemChildren = (
  children: React.ReactNode,
  textStyle: StyleProp<TextStyle>
) =>
  React.Children.map(children, child =>
    typeof child === 'string' || typeof child === 'number'
      ? React.createElement(Text, { style: textStyle }, child)
      : child
  );

export const ProgressListItem = ({ children, style, ...props }: BoxProps) =>
  React.createElement(
    Box,
    {
      focusable: true,
      ...props,
      style: [styles.progressListItem, style],
    },
    renderProgressListItemChildren(children, styles.progressListItemText)
  );

export const ProgressListItemHeader = ({
  children,
  isActive,
  style,
  ...props
}: BoxProps & { isActive?: boolean }) =>
  React.createElement(
    Box,
    {
      focusable: true,
      ...props,
      style: [styles.progressListItem, style],
    },
    renderProgressListItemChildren(children, [
      styles.progressListItemText,
      isActive ? styles.progressListItemHeaderActiveText : styles.progressListItemHeaderText,
    ])
  );

const styles = StyleSheet.create({
  progressList: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: spacing.$4,
    marginTop: spacing.$5,
    width: layout.full,
  },
  progressListItem: {
    alignItems: 'center',
    width: 70,
  },
  progressListItemHeaderActiveText: {
    color: DELIVERY_PROGRESS_COLOR,
  },
  progressListItemHeaderText: {
    color: primitive.$bbqBrown,
  },
  progressListItemText: {
    color: primitive.$greyTwo,
    fontSize: primitive.fontSizes.xs,
    lineHeight: 13.5,
    textAlign: 'center',
  },
});
